import { ComponentProps, FC } from 'react'
import { styled } from '../../lib/stitches'

export const ProgressBarContainer = styled('div', {
  height: '10px',
  marginRight: '10px',
  width: '50px',
  background: 'rgba(102, 116, 245, 0.2)',
  borderRadius: '50px',
  overflow: 'hidden',
  '> div': {
    backgroundColor: '$indigo04',
    height: '100%',
    transition: 'all 500ms'
  },
  variants: {
    error: {
      true: {
        background: 'rgba(248, 90, 58, 0.2)',
        '> div': {
          backgroundColor: 'rgb(248, 90, 58)'
        }
      }
    }
  }
})

type ProgressBarProps = ComponentProps<typeof ProgressBarContainer> & { progress: number }

const ProgressBar: FC<ProgressBarProps> = ({ progress, ...props }) => {
  return (
    <ProgressBarContainer {...props}>
      <div style={{ width: `${progress}%` }}></div>
    </ProgressBarContainer>
  )
}

export default ProgressBar
